import { handleRequest } from "../utilities/requestHandler";

// Pagination is OPT-IN: called with no arguments this returns the full list,
// which is what the dropdown/filter/analytics callers across the app expect.
// Pass a params object and the server returns { rows, row_count, ... } instead.
export const getCustomersCusSites = (options) => {
    if (!options) return handleRequest("get", "/cus_sites/getcustomers");
    const { page = 0, pageSize = 10, search = "", sortField, sortOrder } = options;
    const params = new URLSearchParams({ page, pageSize });
    if (search) params.set("search", search);
    if (sortField) params.set("sortField", sortField);
    if (sortOrder) params.set("sortOrder", sortOrder);
    return handleRequest("get", `/cus_sites/getcustomers?${params.toString()}`);
};

export const updateCustomer = (customerId, customerData) =>
    handleRequest("put", `/cus_sites/customers/${customerId}`, customerData);

export const createCustomer = (customerData) =>
    handleRequest("post", "/cus_sites/customers/create", customerData);

export const deleteCustomers = (ids) =>
    handleRequest("post", "/cus_sites/customers/delete", { ids });

export const downloadCustomerTemplate = () =>
    handleRequest("get", "/cus_sites/customers/template", null, {}, "blob");

export const bulkUploadCustomers = (formData) =>
    handleRequest("post", "/cus_sites/customers/bulk-upload", formData, { 'Content-Type': 'multipart/form-data' });